import { useState, useEffect, useCallback } from 'react'
import { HiArrowPath, HiTrash, HiCheckCircle, HiVideoCamera, HiLink } from 'react-icons/hi2'
import { aiApi } from '../api'
import { ConfirmModal, Loader } from '../ui'
import { useStore } from '../store'

// Bosqich (ochiq / rejalashtirilgan) — neytral, chunki bu shoshilinchlik emas (DESIGN.md 4).
// Rang faqat yakuniy "qo'shildi" signalida qoladi.
const STATUS_LABELS = {
  open:     { label: 'Ochiq',            color: 'var(--ui-st-medium)',  bg: 'var(--ui-st-medium-bg)' },
  planned:  { label: 'Rejalashtirilgan', color: 'var(--ui-st-neutral)', bg: 'var(--ui-st-neutral-bg)' },
  resolved: { label: 'Qo\'shildi',       color: 'var(--ui-st-ok)',      bg: 'var(--ui-st-ok-bg)' },
}

const FILTERS = [
  ['', 'Barchasi'],
  ['open', 'Ochiq'],
  ['planned', 'Rejalashtirilgan'],
  ['resolved', 'Qo\'shildi'],
]

export default function ResourceGaps() {
  const [items, setItems]   = useState([])
  const [total, setTotal]   = useState(0)
  const [loading, setLoading] = useState(true)
  const [error, setError]   = useState(null)
  const [status, setStatus] = useState('')
  const [draft, setDraft]   = useState({})   // id -> { idea_note, suggested_link }
  const [busyId, setBusyId] = useState(null)
  // O'chirish tasdig'i: qaysi yozuv kutilayotgani shu holatda turadi (confirm() o'rniga)
  const [pendingDelete, setPendingDelete] = useState(null)
  const { addToast } = useStore()

  const load = useCallback(async () => {
    setLoading(true); setError(null)
    try {
      const res = await aiApi.resourceGaps({ status, limit: 200 })
      setItems(res.items || [])
      setTotal(res.total || 0)
    } catch (e) {
      setError(e.message || 'Xatolik')
    }
    setLoading(false)
  }, [status])

  useEffect(() => { load() }, [load])

  const getDraft = (row) => draft[row.id] ?? { idea_note: row.idea_note || '', suggested_link: row.suggested_link || '' }
  const setField = (id, field, val) => setDraft(d => ({ ...d, [id]: { ...(d[id] ?? {}), [field]: val } }))

  const save = async (row, patch) => {
    setBusyId(row.id)
    try {
      const d = getDraft(row)
      await aiApi.updateGap(row.id, { idea_note: d.idea_note, suggested_link: d.suggested_link, ...patch })
      await load()
    } catch (e) {
      addToast(e.message || 'Saqlashda xatolik', 'critical')
    }
    setBusyId(null)
  }

  const confirmRemove = async () => {
    const row = pendingDelete
    if (!row) return
    setPendingDelete(null)
    setBusyId(row.id)
    try { await aiApi.deleteGap(row.id); await load() }
    catch (e) { addToast(e.message || 'O\'chirishda xatolik', 'critical') }
    setBusyId(null)
  }

  const inputStyle = {
    width: '100%', borderRadius: 'var(--r)', border: '1px solid var(--border)',
    background: 'var(--surface-2)', color: 'var(--text-1)', fontSize: 13,
  }

  return (
    <div className="page-enter">
      <div className="page-hdr">
        <div className="page-hdr-left">
          <h2>Video bo'shliqlari</h2>
          <p>Bot video/havola bermoqchi bo'lgani-yu bazada topilmagan holatlar. Shu yerdan yetishmayotgan videolarni qo'shing.</p>
        </div>
        <div className="page-hdr-right">
          <button className="btn-refresh-icon" onClick={load} title="Yangilash" aria-label="Yangilash">
            <HiArrowPath aria-hidden="true" />
          </button>
        </div>
      </div>

      {error && (
        <div style={{ background: 'var(--ui-st-critical-bg)', border: '1px solid var(--ui-st-critical)',
          color: 'var(--ui-st-critical)', padding: 12, borderRadius: 'var(--r)', marginBottom: 16 }}>
          {error}
        </div>
      )}

      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        {FILTERS.map(([k, lbl]) => (
          <button key={k || 'all'} onClick={() => setStatus(k)}
            style={{ padding: '6px 12px', borderRadius: 'var(--r)', fontSize: 12, fontWeight: 600, cursor: 'pointer',
              border: `1px solid ${status === k ? 'var(--text-1)' : 'var(--border)'}`,
              background: status === k ? 'var(--text-1)' : 'var(--surface)',
              color: status === k ? 'var(--surface)' : 'var(--text-2)',
              transition: 'background var(--dur-1) var(--ease), border-color var(--dur-1) var(--ease)' }}>
            {lbl}
          </button>
        ))}
        <span style={{ marginLeft: 'auto', alignSelf: 'center', fontSize: 12, color: 'var(--text-3)' }}>
          Jami: {total}
        </span>
      </div>

      {loading ? (
        <Loader state="searching" size="lg" block />
      ) : items.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 48, color: 'var(--text-3)' }}>
          <HiVideoCamera size={40} aria-hidden="true" style={{ opacity: 0.4, marginBottom: 8 }} />
          <div>Hozircha bo'shliqlar yo'q — bot barcha kerakli videolarni topyapti</div>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {items.map(row => {
            const st = STATUS_LABELS[row.status] || STATUS_LABELS.open
            const d = getDraft(row)
            const IntentIcon = row.intent === 'video' ? HiVideoCamera : HiLink
            return (
              <div key={row.id} style={{ background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 'var(--r-lg)', padding: 16 }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12, justifyContent: 'space-between', flexWrap: 'wrap' }}>
                  <div style={{ flex: 1, minWidth: 240 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4, flexWrap: 'wrap' }}>
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 11, fontWeight: 600,
                        color: st.color, background: st.bg, padding: '2px 8px', borderRadius: 'var(--r)' }}>
                        {row.status === 'resolved' && <HiCheckCircle size={13} aria-hidden="true" />}{st.label}
                      </span>
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, fontSize: 11, color: 'var(--text-3)' }}>
                        <IntentIcon size={12} aria-hidden="true" />
                        {row.intent === 'video' ? 'video' : 'havola'} · {row.hit_count}× so'raldi
                      </span>
                      {row.lang && <span style={{ fontSize: 11, color: 'var(--text-3)' }}>· {row.lang}</span>}
                      {row.ticket_number && <span style={{ fontSize: 11, color: 'var(--text-3)', fontFamily: 'var(--mono)' }}>· {row.ticket_number}</span>}
                    </div>
                    <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--text-1)' }}>
                      "{row.query_text}"
                    </div>
                  </div>
                  <button onClick={() => setPendingDelete(row)} disabled={busyId === row.id}
                    style={{ background: 'none', border: 'none', color: 'var(--text-3)', cursor: 'pointer', padding: 4 }}
                    title="O'chirish" aria-label="Yozuvni o'chirish">
                    <HiTrash size={16} aria-hidden="true" />
                  </button>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 12 }}>
                  <div style={{ position: 'relative' }}>
                    <HiLink size={14} aria-hidden="true" style={{ position: 'absolute', left: 10, top: 10, color: 'var(--text-3)' }} />
                    <input
                      value={d.suggested_link}
                      onChange={e => setField(row.id, 'suggested_link', e.target.value)}
                      placeholder="Video/havola URL (masalan t.me/...)"
                      aria-label="Video yoki havola manzili"
                      style={{ ...inputStyle, padding: '8px 10px 8px 30px' }}
                    />
                  </div>
                  <input
                    value={d.idea_note}
                    onChange={e => setField(row.id, 'idea_note', e.target.value)}
                    placeholder="G'oya / izoh (qanday video kerak)"
                    aria-label="G'oya yoki izoh"
                    style={{ ...inputStyle, padding: '8px 10px' }}
                  />
                </div>

                <div style={{ display: 'flex', gap: 8, marginTop: 12, justifyContent: 'flex-end', flexWrap: 'wrap' }}>
                  <button onClick={() => save(row, {})} disabled={busyId === row.id}
                    style={{ padding: '6px 12px', borderRadius: 'var(--r)', border: '1px solid var(--border)', background: 'var(--surface)',
                      color: 'var(--text-1)', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                    Saqlash
                  </button>
                  {row.status !== 'planned' && (
                    <button onClick={() => save(row, { status: 'planned' })} disabled={busyId === row.id}
                      style={{ padding: '6px 12px', borderRadius: 'var(--r)', border: '1px solid var(--border)', background: 'var(--surface)',
                        color: 'var(--text-1)', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                      Rejaga olish
                    </button>
                  )}
                  {row.status !== 'resolved' && (
                    <button onClick={() => save(row, { status: 'resolved' })} disabled={busyId === row.id}
                      style={{ padding: '6px 12px', borderRadius: 'var(--r)', border: 'none', background: 'var(--text-1)',
                        color: 'var(--surface)', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                      Qo'shildi
                    </button>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      )}

      {/* O'CHIRISH TASDIQI — qaytarib bo'lmaydigan amal */}
      <ConfirmModal
        open={!!pendingDelete}
        onClose={() => setPendingDelete(null)}
        onConfirm={confirmRemove}
        title="Yozuvni o'chirish"
        text={`"${pendingDelete?.query_text || ''}" so'rovi bo'yicha bo'shliq yozuvi o'chiriladi. Kiritilgan g'oya va havola ham yo'qoladi.`}
        confirmLabel="O'chirish"
        danger
      />
    </div>
  )
}
